import { BasicEvent } from "../../../planera/events/BasicEvent";
export class HandelssortimentTransportforetagUpdatedMessage extends BasicEvent {
    transportforetagId: number;
    befraktareId: number;
    handelssortimentId: number;
    arbetsorderId: number;
    egenTransport: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "HandelssortimentTransportforetagUpdatedMessage";
    constructor() {
        super(HandelssortimentTransportforetagUpdatedMessage.$type);
    }
}
